import { render, staticRenderFns } from "./TurnaroundDeleteModal.vue?vue&type=template&id=473a4bb0"
import script from "./TurnaroundDeleteModal.vue?vue&type=script&lang=js"
export * from "./TurnaroundDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports